import React from "react";
import { Stepper, Step, StepLabel, Box, Typography } from "@mui/material";
import { stepNameMap } from "utils/@types";

interface ValidationStep {
  name: string;
  step: number;
  executedByRole: string[];
  params: any;
}

interface ValidationStepsProps {
  steps: ValidationStep[];
}

const ValidationSteps: React.FC<ValidationStepsProps> = ({ steps }) => {
  return (
    <Box
      p={2}
      sx={{ width: "100%", display: "flex", justifyContent: "center" }}
    >
      <Stepper nonLinear activeStep={steps.length} orientation="vertical">
        {steps.map((step) => (
          <Step key={step.step}>
            <StepLabel
              sx={{
                border: "2px solid #e0e0e0",
                borderRadius: "4px",
                padding: "1rem",
              }}
              StepIconProps={{ icon: step.step }}
            >
              <Box>
                <Typography variant="subtitle2">
                  Step {step.step}: {stepNameMap[step.name] || step.name}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Executed by: {step.executedByRole.join(", ")}
                </Typography>
              </Box>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default ValidationSteps;
